import React from 'react';
import SidebarSection from '../../../../components/sideBar/SidebarSection';
import PublishedCheck from './PublishedCheck';
import SavedCheck from './SavedCheck';
import URLsCheck from './URLsCheck';
import ImageCheck from './ImageCheck';

const WebsiteChecks = () => {
    return (
        <SidebarSection
            title='website__checks'
            containerClassName='no-border-bottom'
        >
            <ul className='sidebar__quality_signals__container'>
                <SavedCheck />
                <ImageCheck type='logo' />
                <ImageCheck type='icon' />
                <URLsCheck />
                <PublishedCheck />
            </ul>
        </SidebarSection>
    );
};

export default WebsiteChecks;
